import React from "react";
import PropTypes from "prop-types";
import "./loaderRow.scss";
import { gatherClasses } from "../../lib/utils";
import Spinner from "../spinner/spinner";

const LoaderRow = ({ isLoading, className }) => {
  if (isLoading === true) {
    return (
      <div className={gatherClasses(null, className, "oui-inf-table-loader")}>
        <Spinner size="md" />
      </div>
    );
  }
  return null;
};

LoaderRow.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool
};

LoaderRow.defaultProps = {
  isLoading: false
};

LoaderRow.displayName = "OrionLoaderRow";

export default LoaderRow;
